<template>
	<v-container fluid style="margin-top: -12px;">
		<v-progress-linear indeterminate  v-if="isLoading"></v-progress-linear>
		<Bar  v-if="!isLoading"
			:chart-options="chartOptions"
			:chart-data="chartData"
			:chart-id="chartId"
			:dataset-id-key="datasetIdKey"
			:css-classes="cssClasses"
			:height="height"
		/>
	</v-container>
</template>
  
  <script>
  import { Bar } from 'vue-chartjs/legacy'
  import BaseModule from '../../BaseModule'
  import ChartBaseModule from './ChartBaseModule'

  import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Legend,
    BarElement,
    CategoryScale,
    LinearScale
  } from 'chart.js'
  
  ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)
  
  export default {
    name: 'BarChart',
    mixins: [BaseModule, ChartBaseModule],
    components: {
      Bar
    },
		data() {
      return {
      }
    },
    mounted() {
        this.update();
    },
    methods: {

    },    
  }
  </script>